var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "csvActionsModal" },
    [
      _vm.showUploadDownloadModal && !_vm.showUploadStarted
        ? _c(
            "vyModal",
            {
              class: {
                "upload-download-modal": true,
                setup: _vm.showSetupSteps,
              },
              attrs: { "header-title": "CSV Download/Upload" },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
                cancel: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSetupSteps,
                        expression: "showSetupSteps",
                      },
                    ],
                  },
                  [
                    _c("startingGuide", {
                      attrs: { "current-step": _vm.datasetName },
                      on: {
                        "download-clicked": _vm.downloadTemplate,
                        "upload-clicked": _vm.upload,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showSetupSteps,
                        expression: "!showSetupSteps",
                      },
                    ],
                    staticClass: "upload-download-body",
                  },
                  [
                    _c(
                      "section",
                      { staticClass: "download" },
                      [
                        _c("header", [
                          _c("h1", [_vm._v("Download")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "download-icon" },
                            [_c("v-icon", [_vm._v("far fa-arrow-down")])],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "divider" }),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Existing Data")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Download your existing " +
                              _vm._s(
                                _vm.datasetName.charAt(0).toUpperCase() +
                                  _vm.datasetName.slice(1)
                              ) +
                              " dataset to add or edit manually."
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "upload-button",
                            attrs: { depressed: "", color: "#4D52E5" },
                            on: { click: _vm.downloadTemplate },
                          },
                          [_vm._v("Download")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "section",
                      { staticClass: "upload" },
                      [
                        _c("header", [
                          _c("h1", [_vm._v("Upload")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "upload-icon" },
                            [_c("v-icon", [_vm._v("far fa-arrow-up")])],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr", { staticClass: "divider" }),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Ready to upload")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            'Save the file after editing with "' +
                              _vm._s(_vm.datasetName) +
                              '" as the file name. Make sure the file is in CSV format with UTF-8 encoding.'
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "upload-button",
                            attrs: { depressed: "", color: "#4D52E5" },
                            on: { click: _vm.upload },
                          },
                          [_vm._v("Upload")]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "centered" }, [
                          _vm._v(
                            "Upload edits or appends entries and will not remove any data."
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "help-copy mt",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("strong", [_vm._v("Have questions?")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Check out our "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.brandingService.getSupportUrl("csvImports"),
                          target: "_blank",
                        },
                      },
                      [_vm._v("knowledge base article")]
                    ),
                    _vm._v(
                      " containing the details, examples and FAQs about importing and updating data."
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showDownloadModal
        ? _c(
            "vyModal",
            {
              staticClass: "download-modal",
              attrs: { "header-title": "CSV Download/Upload" },
              on: {
                cancel: function ($event) {
                  _vm.showDownloadModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "px-5", attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "div",
                    { staticClass: "modal-header mb-5 text-xs-center" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: "#4CAF50", size: "20" } },
                        [_vm._v("fa fa-check")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.datasetName.charAt(0).toUpperCase() +
                              _vm.datasetName.slice(1)
                          ) + " template downloaded!"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { column: "", "align-center": "" } },
                    [
                      _vm.datasetName === "buildings"
                        ? _c("buildings-guidelines")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.datasetName === "networks"
                        ? _c("networks-guidelines")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.datasetName === "spaces"
                        ? _c("spaces-guidelines")
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.datasetName === "sensors"
                        ? _c("sensors-guidelines")
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "help-copy mt",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("strong", [_vm._v("Have questions?")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Check out our "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.brandingService.getSupportUrl("csvImports"),
                          target: "_blank",
                        },
                      },
                      [_vm._v("knowledge base article")]
                    ),
                    _vm._v(
                      " containing the details, examples and FAQs about importing and updating data."
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showUploadModal
        ? _c(
            "vyModal",
            {
              staticClass: "upload-modal",
              attrs: { "header-title": "CSV Download/Upload" },
              on: {
                close: function ($event) {
                  _vm.showUploadModal = false
                },
                cancel: function ($event) {
                  _vm.showUploadModal = false
                },
              },
            },
            [
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUploadStarted,
                        expression: "showUploadStarted",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "modal-subheader mb-4" },
                      [
                        _c("v-icon", [
                          _vm._v("fa fa-spinner-third fa-spin light-gray"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Uploading...")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-3" }, [
                      _vm._v(
                        "\n          An email will be sent (including any errors) when processing is complete. "
                      ),
                      _c("span", { staticClass: "font-italic" }, [
                        _vm._v(
                          "If you need to upload again, wait until you receive your email notification."
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showUploadSuccessful,
                        expression: "showUploadSuccessful",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "modal-subheader mb-4" },
                      [
                        _c("v-icon", { staticClass: "check-icon" }, [
                          _vm._v("fas fa-check"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Uploaded")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-5" }, [
                      _vm.uploadResponse
                        ? _c("ul", [
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.uploadResponse.added) +
                                  " were successfully added"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.uploadResponse.updated) +
                                  " were successfully updated"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.uploadResponse.errored) +
                                  " were not added or updated due to errors\n                "
                              ),
                              _c(
                                "ul",
                                _vm._l(
                                  _vm.uploadResponse.errors,
                                  function (error, index) {
                                    return _c("li", { key: index }, [
                                      error.id === "row"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      Error: " +
                                                _vm._s(error.id) +
                                                " " +
                                                _vm._s(error.lineNumber) +
                                                " - " +
                                                _vm._s(error.message) +
                                                "\n                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      error.id !== "row"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      Error: " +
                                                _vm._s(error.id) +
                                                " - " +
                                                _vm._s(error.message) +
                                                "\n                    "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.showSetupSteps = false
                            _vm.showUploadModal = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.datasetName.charAt(0).toUpperCase() +
                              _vm.datasetName.slice(1)
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCSVError,
                        expression: "showCSVError",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "modal-subheader mb-4" },
                      [
                        _c("v-icon", { staticClass: "warning-icon" }, [
                          _vm._v("fas fa-exclamation-triangle"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Upload unsuccessful")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.uploadError))]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showCollectorError,
                        expression: "showCollectorError",
                      },
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "modal-subheader mb-4" },
                      [
                        _c("v-icon", { staticClass: "warning-icon" }, [
                          _vm._v("fas fa-exclamation-triangle"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("Upload unsuccessful")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "The collector is currently updating this dataset. Please wait to upload manual edits until the collector upload is finished."
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "help-copy",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showCSVError || _vm.showCollectorError,
                          expression: "showCSVError || showCollectorError",
                        },
                      ],
                    },
                    [
                      _c("strong", [_vm._v("Have questions?")]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Check out our "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.brandingService.getSupportUrl(
                                _vm.csvImports
                              ),
                              target: "_blank",
                            },
                          },
                          [_vm._v("knowledge base article")]
                        ),
                        _vm._v(
                          " containing the details, examples and FAQs about importing and updating data."
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }